export interface SkillCatalogItem {
  id: string;
  name: string;
  category: "调研" | "写作" | "图表" | "工程" | "评审";
  description: string;
  useWhen: string;
  bundled: boolean;
  recommended: boolean;
}

export const SKILL_CATALOG: SkillCatalogItem[] = [
  {
    id: "nature-academic-search",
    name: "nature-academic-search",
    category: "调研",
    description: "多源论文检索、引用核验与 BibTeX 管理。",
    useWhen: "venue 调研、SOTA 对齐、补齐真实参考文献",
    bundled: false,
    recommended: true,
  },
  {
    id: "expand-references",
    name: "expand-references",
    category: "调研",
    description: "从种子论文扩展基础、近邻、桥接、近期和综述工作。",
    useWhen: "方向定位与 Related Work 建图",
    bundled: false,
    recommended: true,
  },
  {
    id: "trace-citations",
    name: "trace-citations",
    category: "调研",
    description: "追踪焦点论文的前驱、后继、桥接与薄弱引用边。",
    useWhen: "验证新颖性与找到真正的最接近工作",
    bundled: false,
    recommended: true,
  },
  {
    id: "nature-reader",
    name: "nature-reader",
    category: "调研",
    description: "形成图表感知、来源可追溯的双语论文精读材料。",
    useWhen: "精读关键论文与提取可比实验协议",
    bundled: false,
    recommended: false,
  },
  {
    id: "researchwrite",
    name: "researchwrite",
    category: "写作",
    description: "证据先于正文、论证先于章节的 proposal-first 写作流程。",
    useWhen: "从证据合同生成论文或重构叙事",
    bundled: false,
    recommended: true,
  },
  {
    id: "sci-diagram-drawing",
    name: "sci-diagram-drawing",
    category: "图表",
    description: "生成可编辑、可导出、经过视觉 QA 的学术框架图。",
    useWhen: "Introduction problem figure 与 framework overview",
    bundled: false,
    recommended: true,
  },
  {
    id: "nature-figure",
    name: "nature-figure",
    category: "图表",
    description: "从冻结数据生成投稿级实验图并检查版式与统计表达。",
    useWhen: "主实验、消融、鲁棒性和超参图",
    bundled: false,
    recommended: true,
  },
  {
    id: "latex:latex-doctor",
    name: "latex:latex-doctor",
    category: "工程",
    description: "诊断本地 LaTeX 工具链与最小编译环境。",
    useWhen: "复制模板后、正式写作前",
    bundled: false,
    recommended: false,
  },
  {
    id: "latex:latex-compile",
    name: "latex:latex-compile",
    category: "工程",
    description: "编译 TeX 项目并选择可用的 Tectonic 或 TeX Live。",
    useWhen: "每次结构性修改后与最终打包前",
    bundled: false,
    recommended: true,
  },
  {
    id: "pdf:pdf",
    name: "pdf:pdf",
    category: "工程",
    description: "渲染并视觉检查 PDF 页面、图表、公式和版式。",
    useWhen: "论文视觉 QA 与 desk-reject 风险检查",
    bundled: false,
    recommended: true,
  },
  {
    id: "nature-reviewer",
    name: "nature-reviewer",
    category: "评审",
    description: "从审稿人视角评估正确性、新颖性、证据和表达。",
    useWhen: "预投稿评审与定位致命问题",
    bundled: false,
    recommended: true,
  },
  {
    id: "nature-response",
    name: "nature-response",
    category: "评审",
    description: "逐点组织审稿意见、修改动作、证据与回复。",
    useWhen: "正式 rebuttal 或 revision",
    bundled: false,
    recommended: false,
  },
  {
    id: "github:yeet",
    name: "github:yeet",
    category: "工程",
    description: "检查变更、提交、推送并形成可审阅的 GitHub 交付。",
    useWhen: "用户明确授权发布代码或 artifact 时",
    bundled: false,
    recommended: false,
  },
  {
    id: "scholarflow-research-orchestrator",
    name: "scholarflow-research-orchestrator",
    category: "写作",
    description: "ScholarFlow 自带：按阶段闸门组织研究任务与文件交付。",
    useWhen: "整个项目的主编排技能",
    bundled: true,
    recommended: true,
  },
  {
    id: "scholarflow-evidence-audit",
    name: "scholarflow-evidence-audit",
    category: "评审",
    description: "ScholarFlow 自带：核对主张、引用、协议、结果与图表来源。",
    useWhen: "实验冻结、写作前和每轮修改后",
    bundled: true,
    recommended: true,
  },
  {
    id: "scholarflow-submission-qa",
    name: "scholarflow-submission-qa",
    category: "工程",
    description: "ScholarFlow 自带：核验 PDF、源文件、artifact 与投稿字段一致性。",
    useWhen: "最终交付与重新打包",
    bundled: true,
    recommended: true,
  },
];

export const DEFAULT_SKILL_IDS = SKILL_CATALOG.filter(
  (skill) => skill.recommended,
).map((skill) => skill.id);
